import React from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { collection, getDocs, getFirestore } from "firebase/firestore";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, Link } from "react-router-dom";
import Feature from "../../components/feature/Feature";
import { getpxusers, setSelectedUser } from "../../services/shareSlice";
import "./users.css";
import app from "../../services/firebaseinit";

const db = getFirestore(app);

const usersDb = "users";

const Users = () => {
  const { pxusers } = useSelector((state) => state.share);

  const dispatch = useDispatch();
  const copyLink = (user) => {
    dispatch(setSelectedUser(user));
    return <Navigate to={`/portfoliax/user${user.uid}`} />;
  };
  const getusers = async () => {
    const usersList = [];
    try {
      const querySnapshot = await getDocs(collection(db, usersDb));
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        // console.log(doc.id, " => ", doc.data());
        usersList.push(doc.data());
      });
    } catch (error) {
      console.log(error);
    }
    dispatch(getpxusers(usersList));
  };
  React.useEffect(() => {
    getusers();
  }, [0]);
  return (
    <div className="gradient__bg pt-5 rounded">
      <div className="portfolioX__portfolioX section__margin rounded" id="wgpt3">
        <div className="portfolioX__portfolioX-feature">
          <Feature
            title="PortfolioX users"
            classX="text-gradient"
            text=""
          />
        </div>
        <div className="portfolioX__portfolioX-container">
          {pxusers &&
            pxusers.map((user, i) => (

              <div key={i} className="p-3 m-5 flex justify-end items-start flex-col rounded-xl h-40 sm:w-72 w-full my-4 eth-card .white-glassmorphism ">
                <div className="flex justify-between flex-col w-full h-full">
                  <div className="flex justify-between items-start">
                    <div className="w-10 h-10 rounded-full border-2 border-white flex justify-center items-center">
                      <img src="https://avatars.githubusercontent.com/u/37832937?v=4" alt="" style={{ height: "35px", width: "35px", borderRadius: "50%" }} />
                    </div>
                    <Link to={`/portfoliax/user/${user.uid}`}>
                      <BsThreeDotsVertical fontSize={17} color="#fff" onClick={() => copyLink(user)} />
                    </Link>
                  </div>
                  <div>
                    <p className="text-white font-light text-sm">
                      {user.uid.toUpperCase()}
                    </p>
                    <p className="text-white font-semibold text-lg mt-1">
                      {user.name}
                    </p>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>

    </div>
  );
};

export default Users;
